import { render, staticRenderFns } from "./RoiCalculator.vue?vue&type=template&id=1e807a84&"
import script from "./RoiCalculator.vue?vue&type=script&lang=js&"
export * from "./RoiCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../fod/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports